import React, {Component} from 'react';

class CheckBox extends Component {
    render() {
        return (
            <div className="filter-group">
                <div className="filter-group-content">
                    <div className="filter-rule">
                        <div className="rule-container padded">
                            <input type="checkbox" className="checkbox" checked={ this.props.isSelected } onChange={ this.props.toggleInput }/>
                            {this.props.label}
                        </div>
                        {this.props.isSelected && this.props.children}
                    </div>
                </div>
            </div>
        )
    }
}
export default CheckBox;

